import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getProducts } from '../../services/products'

export const GET_PRODUCTS = 'GET_PRODUCTS'
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR'
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS'
export const onGetProducts = makeActionCreator(GET_PRODUCTS)
export const onGetProductsError = makeActionCreator(GET_PRODUCTS_ERROR, 'payload')
export const onGetProductsSuccess = makeActionCreator(GET_PRODUCTS_SUCCESS, 'payload')

export const onGetProductsThunk = payload => async dispatch => {
  dispatch(onGetProducts())

  try {
    const { data } = await getProducts({ name: payload.name })

    const products = data.payload?.categorias?.map(category => ({
      name: category.nombre,
      products: category.productos.map(product => ({
        id: product.id,
        name: product.nombre,
        categoryId: product.categoria
      }))
    }))

    dispatch(onGetProductsSuccess({ products }))
  } catch (error) {
    if (error?.code === 404) {
      if (
        error?.originalError?.response?.data?.success === 'OK' &&
        error?.originalError?.response?.data?.payload === 'Not Found'
      ) {
        return dispatch(
          onGetProductsError({
            error: customizeError({
              originalError: error?.originalError,
              code: error?.code,
              reason: 'NOT_FOUND_ERROR'
            }).toObject()
          })
        )
      }
    }

    return dispatch(
      onGetProductsError({
        error: customizeError({
          originalError: error?.originalError,
          code: error?.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}

export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS'
export const onAddProductSuccess = makeActionCreator(ADD_PRODUCT_SUCCESS, 'payload')

export const REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS'
export const onRemoveProductSuccess = makeActionCreator(REMOVE_PRODUCT_SUCCESS, 'payload')

export const UPDATE_PRODUCTS_SAVED_SUCCESS = 'UPDATE_PRODUCTS_SAVED_SUCCESS'
export const onUpdateProductsSavedSuccess = makeActionCreator(UPDATE_PRODUCTS_SAVED_SUCCESS, 'payload')

export const REMOVE_ALL_SUCCESS = 'REMOVE_ALL_SUCCESS'
export const onRemoveAllSuccess = makeActionCreator(REMOVE_ALL_SUCCESS, 'payload')

export const SET_PRODUCTS_DRAFT_SUCCESS = 'SET_PRODUCTS_DRAFT_SUCCESS'
export const onSetProductsDraftSuccess = makeActionCreator(SET_PRODUCTS_DRAFT_SUCCESS, 'payload')

export const onSetProductsDraft = () => (dispatch, getState) => {
  const {
    quote: { products }
  } = getState().quoteStepOne

  if (products !== undefined) {
    const productsSaved = products.map(product => ({
      productId: product.codigoProducto,
      productKey: (Math.random() + 1).toString(36).substring(7),
      productName: product.nombre,
      categoryId: product.idCategoria,
      quantity: product.cantidad,
      unit: product.unidad.id,
      detail: product.descripcion
    }))

    return dispatch(onSetProductsDraftSuccess({ productsSaved }))
  }

  return dispatch(onSetProductsDraftSuccess({ productsSaved: [] }))
}

export const CLEAR_QUOTE_PRODUCTS = 'CLEAR_QUOTE_PRODUCTS'
export const onClearQuoteProducts = makeActionCreator(CLEAR_QUOTE_PRODUCTS, 'payload')
